(function(global){
    /**
     * Klasa odpowiedzialna za utworzenie konfiguracji formularza na podstawie konfiguracji buildera.
     *
     * @param config
     * @constructor
     */
    class Configuration {
        constructor(config) {
            this.init(config);
        }

        init(config){
            this.options = new NS.Utils.OptionsResolver(config);

            this.settings = this.options.getOption("settings", {});
            this.fields = this.options.getOption("fields", {});
            this.bottomButtons = this.options.getOption("bottomButtons", {});
            this.formConfiguration = null;
            this.listeners = null;

            this.createConfiguration();
        }

        createConfiguration() {
            const settings = this.settings;
            settings["type"] = "settings";

            const formConfiguration = [
                settings
            ];

            for (let name in this.fields) {
                if (!this.fields.hasOwnProperty(name)) {
                    continue;
                }

                const fieldDefinition = this.fields[name];
                const fieldConfig = fieldDefinition["configuration"];
                fieldConfig["name"] = name;
                fieldConfig["type"] = fieldDefinition["type"];

                formConfiguration.push(fieldConfig);
            }

            const bottomButtonsBlock = {
                type: "block",
                blockOffset: 0,
                list: []
            };

            const handlers = {};

            for (let id in this.bottomButtons) {
                if (!this.bottomButtons.hasOwnProperty(id)) {
                    continue;
                }

                const buttonDefinition = this.bottomButtons[id];

                bottomButtonsBlock.list.push({
                    "type": "button",
                    "value": buttonDefinition.label,
                    "name": id
                });
                bottomButtonsBlock.list.push({type: "newcolumn"});

                if (typeof buttonDefinition["handler"] != "undefined") {
                    handlers[id + "-click"] = buttonDefinition["handler"];
                }
            }

            if (bottomButtonsBlock.list.length > 0) {
                formConfiguration.push(bottomButtonsBlock);
            }

            this.formConfiguration = formConfiguration;
            this.handlers = handlers;
        }

        getDhtmlxFormConfiguration() {
            return this.formConfiguration;
        }

        getHandlers() {
            return this.handlers;
        }
    }

    global.NS = global.NS || {};
    global.NS.Form = global.NS.Form || {};
    global.NS.Form.Configuration = Configuration;
})(window);
